import React, { useState, useEffect } from 'react';
import axios from '../api/axiosInstance'; // Assuming you have Axios configured
import './AccountSettingsPage.css';

const AccountSettingsPage = () => {
  const [emailSettings, setEmailSettings] = useState({
    fromEmail: '',
    adminEmail: '',
    smtpHost: '',
    smtpPort: '',
    smtpUser: '',
    smtpPass: '',
    enableSsl: false,
  });

  const [password, setPassword] = useState('');
  const [isSensitiveFieldsUnlocked, setIsSensitiveFieldsUnlocked] = useState(false);

  // Fetch the email settings on page load
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get('/settings/email');
        setEmailSettings(response.data);
      } catch (error) {
        console.error('Error fetching email settings:', error);
      }
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEmailSettings((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/settings/email', emailSettings);
      alert('Email settings updated successfully');
    } catch (error) {
      console.error('Error updating email settings:', error);
      alert('Failed to update email settings');
    }
  };

  const handlePasswordSubmit = () => {
    // Check if password is correct (this could be more secure and use an API for password validation)
    if (password === 'LaneSands@Pass01') {
      setIsSensitiveFieldsUnlocked(true);
    } else {
      alert('Incorrect password. Please try again.');
    }
  };

  return (
    <div>
      <h1>Email Settings</h1>
      <form onSubmit={handleSubmit}>
        {/* Non-sensitive fields */}
        <div>
          <label>From Email (comma-separated for multiple emails):</label>
          <input
            type="text"
            name="fromEmail"
            value={emailSettings.fromEmail}
            onChange={handleChange}
            placeholder="Enter multiple emails separated by commas"
            required
          />
        </div>
        <div>
          <label>Admin Email (comma-separated for multiple emails):</label>
          <input
            type="text"
            name="adminEmail"
            value={emailSettings.adminEmail}
            onChange={handleChange}
            placeholder="Enter multiple emails separated by commas"
            required
          />
        </div>

        {/* Sensitive fields - Require password */}
        {!isSensitiveFieldsUnlocked ? (
          <div>
            <h3>Unlock SMTP Settings</h3>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password to edit SMTP settings"
            />
            <button type="button" onClick={handlePasswordSubmit}>
              Unlock SMTP Settings
            </button>
          </div>
        ) : (
          <>
            <h3>SMTP Settings</h3>
            <div>
              <label>SMTP Host:</label>
              <input
                type="text"
                name="smtpHost"
                value={emailSettings.smtpHost}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>SMTP Port:</label>
              <input
                type="number"
                name="smtpPort"
                value={emailSettings.smtpPort}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>SMTP User:</label>
              <input
                type="text"
                name="smtpUser"
                value={emailSettings.smtpUser}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>SMTP Password:</label>
              <input
                type="password"
                name="smtpPass"
                value={emailSettings.smtpPass}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Enable SSL:</label>
              <input
                type="checkbox"
                name="enableSsl"
                checked={emailSettings.enableSsl}
                onChange={handleChange}
              />
            </div>
          </>
        )}

        <button type="submit">Save Settings</button>
      </form>
    </div>
  );
};

export default AccountSettingsPage;
